import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { deAccessDenied } from './AccessDeniedPage/DE-AccessDeniedPage';
import { enAccessDenied } from './AccessDeniedPage/EN-AccessDeniedPage';
import { deCorrelation } from './Correlation/DE-Correlation';
import { enCorrelation } from './Correlation/EN-Correlation';
import measurementParameterTranslations from './measurementParameterTranslations';
import { deSnackbars } from './Snackbars/DE-Snackbars';
import { enSnackbars } from './Snackbars/EN-Snackbars';
import translations from './translations';
import { deTrendIdentification } from './TrendIdentification/DE-TrendIdentification';
import { enTrendIdentification } from './TrendIdentification/EN-TrendIdentification';

const allTranslations = {
  en: {
    translation: {
      ...translations.en.translation,
      ...measurementParameterTranslations.en.translation,
      ...enAccessDenied,
      ...enCorrelation,
      ...enTrendIdentification,
      ...enSnackbars,
    },
  },
  de: {
    translation: {
      ...translations.de.translation,
      ...measurementParameterTranslations.de.translation,
      ...deAccessDenied,
      ...deCorrelation,
      ...deTrendIdentification,
      ...deSnackbars,
    },
  },
};

i18next.use(initReactI18next).init({
  lng:
    import.meta.env.VITE_UENBPQ_ENVIRONMENT === 'dev' || import.meta.env.VITE_UENBPQ_ENVIRONMENT === 'development.local'
      ? 'en'
      : 'de',
  fallbackLng: 'de',
  debug: true,
  resources: allTranslations,
});
